module.exports = __webpack_public_path__ + "img/chevron-down.ae295297.svg";